import React, { Component } from 'react';

import PermissionGrid from './PermissionList/PermissionGrid'

/**
* Class PermissionList
* PermissionList view component
**/
class PermissionList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer les permissions</h2>
        <PermissionGrid ref={"gridPermission"} path="permissions" objectPath="permissions" hidden={false} isComponent={true} />
      </div>
		);
	}

}
export default PermissionList;



// WEBPACK FOOTER //
// ./src/views/Search/PermissionList.js